import { render, staticRenderFns } from "./EmailHandlerLayout.vue?vue&type=template&id=1e24eae8"
import script from "./EmailHandlerLayout.vue?vue&type=script&lang=js"
export * from "./EmailHandlerLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports